var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-4" }, [
          _c("article", { staticClass: "panel" }, [
            _c(
              "p",
              {
                staticClass:
                  "panel-heading has-text-primary has-text-weight-bold"
              },
              [_vm._v("\n            Dados fiscais\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "panel-block" }, [
              _c(
                "div",
                {
                  staticClass: "columns page-pre-invoice-detail__cols",
                  class: { "sc-cte-global": _vm.history.invoices.length > 1 }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.history.invoices, function(so) {
                    return _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/ng#/order-number/" + so.order_number
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(so.order_number) +
                                "\n                  "
                            )
                          ]
                        )
                      ])
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-block" }, [
              _c(
                "div",
                {
                  staticClass: "columns page-pre-invoice-detail__cols",
                  class: { "sc-cte-global": _vm.history.invoices.length > 1 }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.history.invoices, function(so) {
                    return _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "http://status-testing.intelipost.com.br/tracking/" +
                                so.tracking_code,
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(so.tracking_code) +
                                "\n                  "
                            )
                          ]
                        )
                      ])
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-block" }, [
              _c(
                "div",
                {
                  staticClass: "columns page-pre-invoice-detail__cols",
                  class: { "sc-cte-global": _vm.history.invoices.length > 1 }
                },
                [
                  _c("div", { staticClass: "column is-narrow" }, [
                    _c("h6", { staticClass: "has-text-weight-bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getInvoiceLabel(_vm.history.invoices[0].invoice)
                        ) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.history.invoices, function(so) {
                    return _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [
                        _vm._v(_vm._s(_vm.getInvoiceIdentifier(so.invoice)))
                      ])
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-block page-pre-invoice-detail__panel__block"
              },
              [
                _c(
                  "div",
                  { staticClass: "columns page-pre-invoice-detail__cols" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.getSumOfInvoiceCost(
                                _vm.history.invoices,
                                "products_value"
                              )
                            )
                          )
                        )
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-block page-pre-invoice-detail__panel__block"
              },
              [
                _c(
                  "div",
                  { staticClass: "columns page-pre-invoice-detail__cols" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.getSumOfInvoiceCost(
                                _vm.history.invoices,
                                "total_value"
                              )
                            )
                          )
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-4" }, [
          _c("article", { staticClass: "panel" }, [
            _c(
              "p",
              {
                staticClass:
                  "panel-heading has-text-primary has-text-weight-bold"
              },
              [
                _vm._v(
                  "\n            Dados do Documento de Transporte\n          "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-block page-pre-invoice-detail__panel__block"
              },
              [
                _c(
                  "div",
                  { staticClass: "columns page-pre-invoice-detail__cols " },
                  [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [_vm._v(_vm._s(_vm.history.cte.number))])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-block page-pre-invoice-detail__panel__block"
              },
              [
                _c(
                  "div",
                  { staticClass: "columns page-pre-invoice-detail__cols " },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [_vm._v(_vm._s(_vm.history.cte.serie))])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-block page-pre-invoice-detail__panel__block"
              },
              [
                _c(
                  "div",
                  { staticClass: "columns page-pre-invoice-detail__cols " },
                  [
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "column has-text-right sc-pre-invoice-cte__col"
                      },
                      [_c("p", [_vm._v(_vm._s(_vm.history.cte.key))])]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-block page-pre-invoice-detail__panel__block"
              },
              [
                _c(
                  "div",
                  { staticClass: "columns page-pre-invoice-detail__cols" },
                  [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "column has-text-right" }, [
                      _c("p", [_vm._v(_vm._s(_vm.history.cte.company_name))])
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "sc-table",
          {
            attrs: {
              data: _vm.history.historic,
              "default-sort": "last_modified",
              "per-page": _vm.pagination.limit,
              paginated: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "status",
                          label: "Status",
                          width: 300,
                          sortable: ""
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.status.label) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "last_modified",
                          label: "Modificação do status",
                          sortable: ""
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("date")(
                                row.last_modified,
                                "DD/MM/YYYY - HH:mm:ss"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "freight_value",
                          label: "Valor aprovado"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("currency")(row.freight_value)) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "payment_type",
                          label: "Origem do valor"
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(row.payment_type) + "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      { attrs: { field: "observation", label: "Observação" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.observation) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "invoice_number",
                          label: "N° da Fatura"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.invoice_number) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      { attrs: { field: "user", label: "Usuário" } },
                      [_vm._v("\n        " + _vm._s(row.user) + "\n        ")]
                    )
                  ]
                }
              }
            ])
          },
          [
            _c(
              "template",
              { attrs: { slot: "empty" }, slot: "empty" },
              [_c("sc-table-empty")],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "sc-form__footer page-pre-invoice-detail__box-footer"
          },
          [
            _c(
              "div",
              { staticClass: "column has-text-right" },
              [
                _c(
                  "sc-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.$emit("back")
                      }
                    }
                  },
                  [_vm._v("\n          Voltar\n        ")]
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Número do Pedido:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Código de rastreio:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Valor dos produtos:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [_vm._v("Valor TMS:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Número do CTE:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Série do CTE:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Chave do CTE:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [_vm._v("Emissor:")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cac053a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cac053a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-history/ScPreInvoiceDetailHistory.vue
// module id = null
// module chunks = 